import {Http, Response} from '@angular/http';
import {Injectable} from '@angular/core';
import * as Config from "../../app/app.config";
import {AuthProvider} from "../auth/auth";

/*
  Generated class for the TitleProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TitleProvider {

  constructor(
    public http: Http,
    private auth: AuthProvider
  ) {
    console.log('Hello TitleProvider Provider');
  }

  public getTitles() {
    let that = this;
    let headers = that.auth.createApplicationHeadersWithBearer();

    return this.http.get(Config.baseUrl + '/titles/gettitles', {headers: headers})
      .map((res: Response) => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/providers/title/title.ts